import type { ComponentProps, JSX, PropsWithChildren } from 'react';

import { Button } from '@change/ds-core-ui';

type Props = Readonly<{
	onClick?: () => void;
}> &
	ComponentProps<typeof Button>;

export const LoadMoreButton = function LoadMoreButton({
	children,
	onClick,
	ref,
	...rest
}: PropsWithChildren<Props> & {
	ref?: React.RefObject<HTMLButtonElement | null>;
}): JSX.Element {
	return (
		<Button variant="secondary" onClick={onClick} ref={ref} {...rest}>
			{children}
		</Button>
	);
};
